import { action } from 'typesafe-actions'
import { Student, StudentPreferences, StudentTypes } from './types'
import { AuthTypes } from '../auth/types'

export const updateStudent = (profile: Student): any => action(AuthTypes.SIGN_IN_SUCCESS, profile)

export const editStudentRequest = (payload: Partial<Student>): any =>
  action(StudentTypes.EDIT_STUDENT_REQUEST, payload)

export const editStudentIdentification = (payload: any): any =>
  action(StudentTypes.EDIT_STUDENT_IDENTIFICATION, payload)

export const editStudent = (profile: Student): any => action(StudentTypes.EDIT_STUDENT, profile)

export const editPreference = (preference: StudentPreferences): any =>
  action(StudentTypes.EDIT_STUDENT_PREFERENCE, preference)
